// extracted by mini-css-extract-plugin
module.exports = {"jcPrimary":"#41c8c3","container":"container","logo":"logo","heading":"heading","message":"message","link":"link","link--large":"link--large"};